import { render, staticRenderFns } from "./ObjectTelegramLinks.vue?vue&type=template&id=295c5cad&scoped=true&"
import script from "./ObjectTelegramLinks.vue?vue&type=script&lang=js&"
export * from "./ObjectTelegramLinks.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTelegramLinks.vue?vue&type=style&index=0&id=295c5cad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295c5cad",
  null
  
)

export default component.exports